









































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getUuid } from "@src/utils/common";
import { t } from "@src/locale";

@Component({
  model: {
    prop: "fileUrls",
    event: "change"
  }
})
export default class SbFileUpload extends Vue {
  static componentName = "SbFileUpload";
  @Prop({ default: 1 })
  maxNum: number;

  @Prop({ default: "image" }) // image video
  fileType: string;

  @Prop({ default: () => [] })
  defaultFileList: any;

  @Prop({ default: false, type: Boolean })
  readonly: boolean;

  @Prop({ default: () => [] })
  fileUrls: any;

  @Prop({ type: Function })
  getTokenMethod: any;

  isLoading: boolean = false;
  get allUrl() {
    return this.fileList.map(item => item.url);
  }
  uploadUrl: string = "";
  uploadTokenObj: any = {};
  fileList: any = [];
  uploadFileCb(file) {
    return this.getTokenMethod().then(data => {
      this.uploadTokenObj = {
        url: data.data.host,
        key: `${data.data.dir}/${getUuid(15)}/${file.name}`,
        policy: data.data.policy,
        OSSAccessKeyId: data.data.accessId,
        Signature: data.data.signature,
        success_action_status: 200,
        domain: data.data.domain
      };
      this.uploadUrl = data.data.host;
    });
  }
  async beforeAvatarUpload(file) {
    if (this.fileType === "video" && file.type !== "video/mp4") {
      this.$message.warning(t("sb.only-support-pm4"));
      return;
    } else {
      this.isLoading = true;
      await this.uploadFileCb(file);
    }
  }
  handleUploadSuccess(response, file, fileList) {
    if (file.status === "success") {
      this.fileList.push({
        name: file.name,
        url: this.uploadTokenObj.domain + "/" + this.uploadTokenObj.key
      });
      this.emitChange();
      this.$emit("fileChange");
      this.isLoading = false;
    }
  }
  handleDeleteImg(i) {
    this.fileList.splice(i, 1);
    this.emitChange();
  }
  emitChange() {
    if (this.maxNum <= 1) {
      if (this.fileList.length > 0) {
        this.$emit("change", this.fileList[0].url);
      } else {
        this.$emit("change", "");
      }
    } else {
      this.$emit(
        "change",
        this.fileList.map(item => item.url)
      );
    }
  }
  defaultUrl: any = [];
  @Watch("defaultFileList", {
    immediate: true
  })
  watchDefaultFileList(val) {
    if (val.length) {
      val.forEach(item => {
        if (item.url && !this.defaultUrl.includes(item.url)) {
          console.log("[ this.fileList ]", this.fileList);
          this.fileList.push(item);
          this.defaultUrl.push(item.url);
          this.emitChange();
        }
      });
    } else {
      this.fileList = [];
      this.defaultUrl = [];
      this.emitChange();
    }
  }
}
